<template>
    <div style="overflow: hidden;">
        <div class="container" ref="container">
            <img src="@/assets/footerview/footer-one-icon.png" />
        </div>
        <div class="container1">
            <div>
                <h1 class="wow animate__lightSpeedInLeft" data-wow-delay="0.1s">a difference</h1>
                <h3 class="wow animate__lightSpeedInLeft" data-wow-delay="0.2s">how did we make a difference?</h3>
            </div>
            <img src="@/assets/footerview/footer-one-icon1.png" />
            <div>
                <div class="wow animate__bounceInUp" data-wow-delay="0.1s">
                    <h5>Design</h5>
                    <p> Fun &amp; Interactive design for the Second Screen Platform engagement to appeal to an American
                        audience. </p>
                </div>
                <div class="wow animate__bounceInUp" data-wow-delay="0.2s">
                    <h5>Content</h5>
                    <p>Synergetic content for viewers and podcasters. We listed out highly-desired topics, researched
                        them
                        and gave out informative posts. Collectively filling out the backend content to draw more
                        listeners.
                    </p>
                </div>
                <div class="wow animate__bounceInUp" data-wow-delay="0.3s">
                    <h5>Operations handling</h5>
                    <p>Curating and uploading 1000 monthly episodes on the platform! Adding content-based engagement
                        interstitials in the backend allows users to engage in real time with the platform and increases
                        revenue opportunities.</p>
                </div>
            </div>
        </div>
        <div class="container2">
            <div>
                <div><img src="@/assets/footerview/footer-one-icon2.png" width="100%" /></div>
                <div>
                    <h3 class="wow animate__fadeInRight">The Client</h3>
                    <p class="wow animate__fadeInRight" data-wow-delay="0.1s">Taking a straight-forward approach to
                        engaging the listers and bringing more podcasters we helped
                        them populate 600+ monthly episodes with over 3000 points of engagement!</p>
                    <p class="wow animate__fadeInRight" data-wow-delay="0.2s">We focused on guiding and engaging
                        listeners, traffic inflow for customers, and retaining customers.
                    </p>
                </div>
            </div>

            <div>
                <div><img src="@/assets/footerview/footer-one-icon3.png" width="100%" /></div>
                <div>
                    <h3 class="wow animate__fadeInLeft">The Solution</h3>
                    <p class="wow animate__fadeInLeft" data-wow-delay="0.1s">Taking a straight-forward approach to
                        engaging the listers and bringing more podcasters we helped
                        them populate 600+ monthly episodes with over 3000 points of engagement!</p>
                    <p class="wow animate__fadeInLeft" data-wow-delay="0.2s">We focused on guiding and engaging
                        listeners, traffic inflow for customers, and retaining customers.
                    </p>
                </div>
            </div>
        </div>

        <div class="container3">
            <div><img src="@/assets/footerview/footer-one-icon4.png" width="70%" /></div>
            <div>
                <div v-for="(item, index) in accordionItems" :key="index" class="accordion-item"
                    :class="{ 'active': activeIndex === index }" @click="toggleAccordion(index)">
                    <div class="accordion-header">
                        <h3>{{ item.title }}</h3>
                    </div>
                    <div class="accordion-content" ref="accordionContents">
                        <p>{{ item.content }}</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="container4">
            <div>Our aim was to bring in and retain more listeners for the platform that we also helped create event
                cards, and access for the listeners to topic-related articles.</div>
            <div><img src="@/assets/footerview/footer-one-icon5.png" /></div>
        </div>
        <div><img src="@/assets/footerview/footer-one-icon6.png" width="80%" /></div>
    </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue';

const container = ref(null);
let observer = null;

const handleIntersection = (entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('clip-path-effect');
        } else {
            entry.target.classList.remove('clip-path-effect');
        }
    });
};

onMounted(() => {
    observer = new IntersectionObserver(handleIntersection, {
        threshold: 0.1 // 当元素 10% 进入视口时触发
    });
    if (container.value) {
        observer.observe(container.value);
    }
});

onUnmounted(() => {
    if (observer && container.value) {
        observer.unobserve(container.value);
    }
});

const activeIndex = ref(null);
const accordionContents = ref([]);

const accordionItems = [
    {
        title: 'Content Curation',
        content: 'Curation of over 1000 podcasts within 60 days of engagement leading to more returning users for the application'
    },
    {
        title: 'Digital Engagement',
        content: 'Signed up 50+ podcasters within 4 weeks of Social and digital engagement through direct engagement with content creators'
    },
];

const toggleAccordion = async (index) => {
    if (activeIndex.value === index) {
        activeIndex.value = null;
    } else {
        activeIndex.value = index;
    }
    await nextTick();
    setAccordionHeight(index);
};


const setAccordionHeight = (index) => {
    accordionContents.value.forEach((content, i) => {
        if (i === index && activeIndex.value === index) {
            content.style.maxHeight = content.scrollHeight + 'px';
        } else {
            content.style.maxHeight = '0px';
        }
    });
};
</script>

<style lang="less" scoped>
.container {
    background-image: url("../../assets/footerview/footer-one-bg.png");
    min-height: 100vh;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    -webkit-clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
    transition: clip-path 1s ease, -webkit-clip-path 1s ease; // 添加过渡效果
    position: relative;

    &.clip-path-effect {
        -webkit-clip-path: polygon(0 0, 100% 0, 100% 100%, 0 75%);
        clip-path: polygon(0 0, 100% 0, 100% 100%, 0 75%);
    }

    >img:nth-child(1) {
        width:20vw;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}

.container1 {
    position: relative;

    >div:nth-child(1) {
        text-align: left;
        text-transform: uppercase;

        h1 {
            color: rgba(10, 15, 56, .1);
            letter-spacing: 10px;
            font-size: 5vw;
            margin: 0px;
            padding: 0px;
            margin-top: -45px;
        }

        h3 {
            font-size: max(2vw, 14px);
            margin: 0px;
            padding: 0px;
            margin-top: -55px;
            margin-left: 20px;
        }
    }

    >img:nth-child(2) {
        position: absolute;
        right: 3%;
        width:18%;
        transform: translateY(-65%);
    }

    >div:nth-child(3) {
        display: flex;
        flex-wrap: wrap;
        gap: 3%;
        margin: 15% 10% 10% 10%;

        >div {
            flex: 1;
            min-width: 200px;
            box-shadow: 0 1px 3px rgba(0, 0, 0, .12), 0 1px 2px rgba(0, 0, 0, .24);
            padding: 3% 2%;
            margin-bottom: 20px;
            color: #97a4be;
            font-weight: 300;
            line-height: 1.5;

            >h5 {
                color: #233148;
                font-size: max(1.2vw, 14px);
                margin: 3% 0%;
                text-transform: uppercase;
            }

            p {
                font-size: max(1vw, 12px);
            }
        }
    }
}

.container2 {
    >div {
        display: flex;
        flex-wrap: wrap;
        background-color: #f5f6fa;
        text-align: left;
        font-family: Space Grotesk, sans-serif !important;

        >div:nth-child(1) {
            flex: 2;
            min-width: 300px;
        }

        >div:nth-child(2) {
            flex: 3;
            min-width: 300px;
            padding: 3%;
        }

        h3 {
            font-weight: 400;
            font-size: max(2vw, 14px);
        }

        p {
            line-height: 1.7;
            color: #1a2e42;
            font-weight: 300;
        }
    }

    >div:nth-child(2) {
        background-color: #fff;
        flex-direction: row-reverse;
    }
}

.container3 {
    display: flex;
    flex-wrap: wrap;
    width: 90%;
    margin: auto;

    >div {
        flex: 3;
        padding-top: 5%;
        min-width: 300px;

        img {
            width: 80%;
            z-index: 100;
            position: relative;
        }
    }

    >div:nth-child(2) {
        flex: 4;
        position: relative;
        z-index: 101;
        text-align: left;

        .accordion-item {
            background-color: #fff;
            color: #172d43;
            border: 1px solid #ddd;
            margin-bottom: 10px;
            cursor: pointer;
            padding: 3%;
            box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);
            transition: background-color 0.3s, color 0.3s;

            &.active {
                background-color: #0a0f38;
                color: #fff;
            }

            .accordion-header {
                >h3 {
                    margin: 0px;
                }
            }

            .accordion-content {
                overflow: hidden;
                max-height: 0;
                transition: max-height 0.3s ease-out;

                p {
                    padding: 20px 0px 10px 0px;
                    margin: 0px;
                }
            }
        }
    }
}

.container4 {
    display: flex;
    flex-wrap: wrap;
    position: relative;
    z-index: 99;

    &::before {
        position: absolute;
        width: 100%;
        height: 100%;
        top: -200px;
        left: 0;
        content: "";
        background-color: #f5f6fa;
        transform: skewY(10deg);
        z-index: 10;
    }

    color: #172d43;
    line-height: 1.5;
    padding: 7%;
    gap: 2%;
    font-weight: 400;
    font-size: max(2vw, 14px);
    text-align: left;

    >div {
        flex: 3;
        position: relative;
        z-index: 100;
        min-width: 300px;

        >img {
            width: 100%;
        }
    }

    >div:nth-child(2) {
        flex: 4;
    }
}

@media all and (max-width:600px) {
    .container {
        min-height: 0px;
        aspect-ratio: 5/9 !important;

        >img:nth-child(1) {
            width: 200px;
            top: 15%;
            left: 50%;
        }
    }

    .container1 {
        position: relative;

        >div:nth-child(1) {
            text-align: left;
            text-transform: uppercase;

            h1 {
                margin-top: -45px;
            }

            h3 {
                margin-top: -10px;
                margin-left: 0px;
            }
        }

        >img:nth-child(2) {
            position: absolute;
            right: 3%;
            width:200px;
            transform: translateY(-110%);
        }
    }

    .container2 {
        width: 90%;
        margin: auto;
    }
}
</style>